class ContactService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getContacts(params) {
    return this.apiService.get('/api/v1/one/contact', params);
  }

  createContact(params) {
    return this.apiService.post('/api/v1/one/contact', params);
  }

  updateContact(params) {
    return this.apiService.put(`/api/v1/one/contact/${params.id}`, params);
  }

  deleteContacts(params) {
    return this.apiService.delete('/api/v1/one/contact', params);
  }
}

export default ContactService;
